import React, { useEffect, useState, useCallback } from 'react';
import './Instrucoes.css';
import './Instrucoes.scss';
import '../../../src/styles/mediaqueries.css';

const Instrucoes = () => {
    const [isVisible, setIsVisible] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);
  
    const handleScroll = useCallback(() => {
      if (window.scrollY > 100 && !fadeOut) {
        setFadeOut(true); 
      } else if (window.scrollY <= 100 && fadeOut) {
        setFadeOut(false);
        setIsVisible(true);
      }
    }, [fadeOut]);
  
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);
  
    useEffect(() => {
      if (fadeOut) {
        const timeoutId = setTimeout(() => setIsVisible(false), 300);
        return () => clearTimeout(timeoutId);
      }
    }, [fadeOut]);

  return (
    isVisible && (
      <div className={`instrucoes-container ${fadeOut ? 'fade-out' : ''}`}>
        <div className="instrucao instrucao-menu">
            <svg width="24" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow-icon">
                <path d="M15 4H4V1" stroke="#344c3d"/>
                <path d="M14.5 4H3.5H0" stroke="#344c3d"/>
                <path d="M15.8536 4.35355C16.0488 4.15829 16.0488 3.84171 15.8536 3.64645L12.6716 0.464466C12.4763 0.269204 12.1597 0.269204 11.9645 0.464466C11.7692 0.659728 11.7692 0.976311 11.9645 1.17157L14.7929 4L11.9645 6.82843C11.7692 7.02369 11.7692 7.34027 11.9645 7.53553C12.1597 7.7308 12.4763 7.7308 12.6716 7.53553L15.8536 4.35355ZM15 4.5L15.5 4.5L15.5 3.5L15 3.5L15 4.5Z" fill="#344c3d"/>
            </svg>
            <div className='instrucoes-text'>
                <span>Explore o site e descubra mais sobre<br /> nós, nossos serviços e nosso espaço!</span>
            </div>
        </div>
        <div className="instrucao instrucao-whatsapp">
            <svg width="24" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow-icon">
                <path d="M15 4H4V1" stroke="#344c3d"/>
                <path d="M14.5 4H3.5H0" stroke="#344c3d"/>
                <path d="M15.8536 4.35355C16.0488 4.15829 16.0488 3.84171 15.8536 3.64645L12.6716 0.464466C12.4763 0.269204 12.1597 0.269204 11.9645 0.464466C11.7692 0.659728 11.7692 0.976311 11.9645 1.17157L14.7929 4L11.9645 6.82843C11.7692 7.02369 11.7692 7.34027 11.9645 7.53553C12.1597 7.7308 12.4763 7.7308 12.6716 7.53553L15.8536 4.35355ZM15 4.5L15.5 4.5L15.5 3.5L15 3.5L15 4.5Z" fill="#344c3d"/>
            </svg>
            <div className='instrucoes-text'>
                <span>Entre em contato!</span>
            </div>
        </div>
      </div>
    )
  );
};

export default Instrucoes;
